import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import * as serviceWorkerRegistration from './serviceWorkerRegistration';

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);

// Register service worker for PWA functionality
serviceWorkerRegistration.register({
  onSuccess: () => {
    console.log('PWA: Application mise en cache avec succès pour utilisation hors ligne');
  },
  onUpdate: () => {
    console.log('PWA: Nouvelle version disponible');
    // You could show a user notification here
  }
});

// Request notification permission for PWA features
serviceWorkerRegistration.requestNotificationPermission();
